<template>
  <div class="relative flex items-center justify-center">
    <!-- Outer Coin SVG -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g filter="url(#filter0_i_10002_695)">
        <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_10002_695)" />
      </g>
      <circle
        cx="12"
        cy="12"
        r="11.75"
        stroke="url(#paint1_linear_10002_695)"
        stroke-width="0.5"
      />
      <defs>
        <filter
          id="filter0_i_10002_695"
          x="0"
          y="0"
          width="24"
          height="25"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_10002_695"
          />
        </filter>
        <linearGradient
          id="paint0_linear_10002_695"
          x1="24"
          y1="0"
          x2="0"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFCA17" />
          <stop offset="1" stop-color="#977400" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10002_695"
          x1="24"
          y1="0"
          x2="0"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EFEDDB" />
          <stop offset="1" stop-color="#AB8F54" />
        </linearGradient>
      </defs>
    </svg>

    <!-- Inner Ellipse SVG -->
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      class="absolute"
    >
      <g filter="url(#filter0_d_10002_696)">
        <circle
          cx="11.9996"
          cy="11"
          r="10.5"
          stroke="url(#paint0_linear_10002_696)"
          stroke-width="0.5"
          stroke-linecap="round"
          stroke-dasharray="0 1"
          shape-rendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_10002_696"
          x="0.749634"
          y="0.25"
          width="22.5"
          height="22.5"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10002_696"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10002_696"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_10002_696"
          x1="11.9996"
          y1="0.5"
          x2="11.9996"
          y2="21.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#EFEDDB" />
          <stop offset="1" stop-color="#AB8F54" />
        </linearGradient>
      </defs>
    </svg>

    <!-- Number Text -->
    <span class="absolute text-white text-[10px] font-bold font-serif">{{
      points
    }}</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  points: number;
}>();
</script>

<style scoped>
.coin-svg {
  position: relative;
  width: 100px;
  height: 100px;
}

.absolute {
  position: absolute;
  inset: 0;
}

span {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
